// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@conklin/App/Components/Common/XngZone";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

const enum fields {}

interface OwnProps extends WidgetProps {
    fields: {};
}

type Props = WidgetProps & OwnProps;

export interface HomePageMyAccountLayoutStyles {
    container?: InjectableCss;
    accountOverview?: InjectableCss;
    accountTabs?: InjectableCss;
    myProjects?: InjectableCss;
}

export const homePageMyAccountLayoutStyles: HomePageMyAccountLayoutStyles = {};

const styles = homePageMyAccountLayoutStyles;

const HomePageMyAccountLayout: FC<Props> = ({ id, fields }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="HomePageMyAccountLayout">
            <StyledWrapper {...styles.accountOverview}>
                <XngZone zoneName="account" contentId={id} hint="Account Overview" />
            </StyledWrapper>
            <StyledWrapper {...styles.accountTabs}>
                <XngZone zoneName="tabs" contentId={id} hint="Account Tabs" />
            </StyledWrapper>
            <StyledWrapper {...styles.myProjects}>
                <XngZone zoneName="projects" contentId={id} hint="My Projects" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: HomePageMyAccountLayout,
    definition: {
        group: "Layout" as any,
        displayName: "Homr page my account section layout",
        allowedContexts: ["HomePage"],
    },
};

export default widgetModule;
